import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VariablesService } from '../variables/variables.service';
import { API_URLS } from 'src/environments/api-urls';
import { UtilService } from '../util/util.service';

interface IHeaders { [key: string]: string }

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  readonly http = inject(HttpClient);
  readonly httpBypass = new HttpClient(inject(HttpBackend));
  readonly util = inject(UtilService);
  readonly vars = inject(VariablesService);
  readonly defaultHeaders: IHeaders = { 'Content-Type': 'application/json' };

  getUrl(endpoint: string): string {
    return endpoint.startsWith('http') ? endpoint : `${this.vars.domain_details.apiUrl}${endpoint}`;
  }
  getOptions(endpoint: string, params?: any, data?: any, headers?: IHeaders) {
    params = { ...params, ...this.util.urlToParamObj(endpoint) };
    return {
      headers: this.getHeaders(headers),
      params: params instanceof HttpParams ? params : new HttpParams({ fromObject: params || {} }),
      ...(data ? { body: data } : {})
      // ...(data ? { body: JSON.stringify(data) } : {})
    };
  }
  getHeaders(customHeaders?: IHeaders): HttpHeaders {
    return new HttpHeaders({ ...this.defaultHeaders, ...customHeaders });
  }
  request(method: 'get' | 'post' | 'put' | 'delete', endpoint: string, params?: any, data?: any, headers?: IHeaders) {
    return this.http.request(method, this.getUrl(endpoint), this.getOptions(endpoint, params, data, headers));
  }
  requestBackend(method: 'get' | 'post' | 'put' | 'delete', endpoint: string, params?: any, data?: any, headers?: IHeaders) {
    return this.httpBypass.request(method, this.getUrl(endpoint), this.getOptions(endpoint, params, data, headers));
  }


  constructor() { }

  public httpOptions: object = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  get(path: string, qParams?: any, headers?: IHeaders) {
    const { url, options } = this.handleReq(path, headers);
    return this.http.get(url, { ...options, params: qParams });
  }

  post(path: string, data?: any, headers?: IHeaders) {
    const { url, options, body } = this.handleReq(path, headers, data);
    return this.http.post(url, JSON.stringify(body || {}), options);
  }

  put(path: string, data?: any, headers?: IHeaders) {
    const { url, options, body } = this.handleReq(path, headers, data);
    return this.http.put(url, JSON.stringify(body || {}), options);
  }

  delete(path: string, headers?: IHeaders) {
    const { url, options } = this.handleReq(path, headers);
    return this.http.delete(url, options);
  }

  setReqOptions(headers: IHeaders = { 'Content-Type': 'application/json' }) {
    if (this.vars.authToken) {
      headers = {
        ...headers,
        Authorization: `Bearer ${this.vars.authToken}`
      }
    }
    return {
      headers: new HttpHeaders(headers)
    };
  }

  handleReq(path: string, headers?: IHeaders, data?: any): { url: string, body?: any, options?: any } {
    const options = this.setReqOptions(headers);
    let body = data;
    if (body && this.vars.utm_url_obj) {
      body = { ...body, ...this.vars.utm_url_obj };
    } else if (this.vars.utm_url_string) {
      path += `${path.includes('?') ? '&' : '?'}${this.vars.utm_url_string}`;
    }
    const url = `${!path.startsWith('http') ? (this.vars.domain_details?.apiUrl || environment.API_BASE_URL) : ''}${path}`;
    return { url, body, options };
  }

  fileUpload(path: string, data?: any, headers?: IHeaders) {
    const { url } = this.handleReq(path, headers);
    const fd = new FormData();
    fd.append('file', data);
    const options = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.vars.authToken}`
      }),
    };
    return this.http.post(url, fd, options);
  }

  getShortURL(payload: any): Promise<string> {
    return new Promise((resolve, reject) => {
        this.http.post<{ data: { data: { short_url: string } } }>((this.vars.domain_details?.apiUrl || environment.API_BASE_URL) + API_URLS.GET_SHORT_URL, payload, this.httpOptions).
          subscribe({next: (res: any) => {
            resolve(res.data.data.short_url);
          }, error: (error) => {
            reject(false);
          }});
    });
  }
}
